import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import clsx from 'clsx'

const useStyles = makeStyles({
    root: {
        height: 92 / 1.8,
        width: 382 / 1.8,
        cursor: 'pointer',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundImage:
            'url(/images/google/btn_google_signin_dark_normal_web@2x.png)',
        '&:focused': {
            backgroundImage:
                'url(/images/google/btn_google_signin_dark_focus_web@2x.png)',
        },
        '&:active': {
            backgroundImage:
                'url(/images/google/btn_google_signin_dark_pressed_web@2x.png)',
        },
    },
})

const GoogleSignInButton = ({ className, ...props }) => {
    const classes = useStyles()
    return <div className={clsx(classes.root, className)} {...props} />
}

export default GoogleSignInButton
